export enum FeatureTypes {
  ASSETS = 'featureAssets',
  CONTACTS = 'featureContacts',
  SHARES = 'featureShares',
  REPORTS = 'featureReports',
  TASK = 'featureTask',
  VEHICLE = 'featureVehicle',
}
